const SAFE_RELATIVE_PREFIXES = [
  "/account",
  "/settings",
  "/admin",
  "/auth",
  "/api/oauth/",
  "/services",
];

export function isClientSafeRedirect(url: string): boolean {
  if (!url || typeof url !== "string") {
    return false;
  }

  if (url.startsWith("//") || url.startsWith("/\\")) {
    return false;
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    try {
      const parsed = new URL(url);
      if (typeof window !== "undefined" && parsed.host === window.location.host) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  if (url.startsWith("/")) {
    for (const prefix of SAFE_RELATIVE_PREFIXES) {
      if (url.startsWith(prefix)) {
        return true;
      }
    }
    return false;
  }

  return false;
}

export function safeRedirect(url: string, fallback = "/account"): void {
  const target = isClientSafeRedirect(url) ? url : fallback;
  if (target.startsWith("http") || target.startsWith("/api/")) {
    window.location.replace(target);
  } else {
    window.location.replace(target);
  }
}
